import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'config/redux'
import { Task } from 'constants/interfaces'
import { getTask } from 'redux/actions/tasks_v2'
import { MediaGalleryEntry } from '../model/mediaGallery'

export function useMediaGalleryReview(tid: string, recurrenceTs: string | null, entry: MediaGalleryEntry) {
  const dispatch: AppDispatch = useDispatch()
  const [task, setTask] = useState<Task | null>(null)
  const [error, setError] = useState(false)
  const [attempt, setAttempt] = useState(0)
  const target = entry.contexts.find((context) => context.contextId === entry.contextId)

  const retry = () => setAttempt((value) => value + 1)

  useEffect(() => {
    let active = true
    setTask(null)
    setError(false)

    if (!target) {
      setError(true)
      return
    }

    dispatch(
      getTask({
        tid,
        task_context_id: target.taskContextId,
        result_context_id: target.contextId,
        recurrence_ts: recurrenceTs,
        shouldApply: () => active,
      })
    ).then((response) => {
      if (!active) return

      if (response.task) {
        setTask({ ...response.task, dashboardContextId: target.contextId, recurrence_ts: recurrenceTs || '' })
      } else {
        setError(true)
      }
    })

    return () => {
      active = false
    }
  }, [dispatch, tid, recurrenceTs, target, attempt])

  return { task, error, retry }
}
